/**
 * Created by swandelow on 9/20/16.
 */
angular.module('CarsSaraBo').directive('requireiftrue', ['$compile', function ($compile) {
    return {
        require: '?ngModel',
        requireiftrue: '=',

        link: function (scope, el, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            if (attrs.requireiftrue === "true") {
                el.attr('ng-required', true);
                el.removeAttr('requireiftrue');
                $compile(el[0])(scope);
            }

            scope.$watch('isRequired', function () {
                el.attr('ng-required', scope.isRequired);
                el.removeAttr('requireiftrue');
                $compile(el[0])(scope);
            });
        }
    };
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/directives/requireiftrue_directive.js
// module id = 883
// module chunks = 3